import { NavLink, useNavigate } from 'react-router-dom';
import { Package, Boxes, Cpu, LayoutGrid, MoreHorizontal } from 'lucide-react';

const primaryItems = [
  { path: '/products', icon: Package, label: 'Products' },
  { path: '/supplies', icon: Boxes, label: 'Supplies' },
  { path: '/production', icon: Cpu, label: 'Production' },
  { path: '/inventory', icon: LayoutGrid, label: 'Inventory' },
];

interface BottomNavProps {
  onMoreClick: () => void;
}

export function BottomNav({ onMoreClick }: BottomNavProps) {
  const navigate = useNavigate();

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white dark:bg-charcoal-800 border-t border-gray-200 dark:border-charcoal-700 safe-area-pb"
      aria-label="Primary navigation"
    >
      <div className="flex items-stretch justify-around h-16">
        {primaryItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 min-w-0 px-1 gap-0.5 text-xs font-medium transition-colors min-h-[44px] ${
                isActive
                  ? 'text-amber-600 dark:text-amber-450'
                  : 'text-gray-500 dark:text-warm-sand'
              }`
            }
          >
            <item.icon className="w-5 h-5 shrink-0" />
            <span className="truncate max-w-full">{item.label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          onClick={() => {
            onMoreClick();
            navigate('/');
          }}
          className="flex flex-col items-center justify-center flex-1 min-w-0 px-1 gap-0.5 text-xs font-medium text-gray-500 dark:text-warm-sand min-h-[44px]"
          aria-label="More menu"
        >
          <MoreHorizontal className="w-5 h-5" />
          <span>More</span>
        </button>
      </div>
    </nav>
  );
}
